import Dispatcher from "../dispatcher";

export default {
  loadAccessCodes() {
    Dispatcher.emit(Dispatcher.UPDATE_ACCESS_CODES);
  }
};
